export default __webpack_public_path__ + "static/media/050-pulley.5259149b.svg";